export default "__VITE_ASSET__CxEorhrj__"